/******************************************
*  Author : Riccardo Di Dato
*  Created On : Mon May 23 2022
*  File : SimpleEventHandler.ts
*******************************************/
import { EventHandlerMixin } from "./mixin.js";
export class SimpleEventHandler extends EventHandlerMixin(class base {
}) {
}
